module.exports = function anonymous(it
/**/) {
var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function (doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());var out='<a href="'+encodeHTML(it.Url)+'" class="search-result"> <span class="search-result__title">'+encodeHTML(it.Title)+'</span> <p class="search-result__description">'+encodeHTML(it.Description)+'</p></a>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/filters/search.dot
// module id = 259
// module chunks = 0 1